import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3883b1e4")

_pushScopeId("data-v-3883b1e4")
const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-flex-row p-jc-center kn-flex"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_InlineMessage = _resolveComponent("InlineMessage")
  const _component_FilterCard = _resolveComponent("FilterCard")

  return (_openBlock(), _createBlock("div", {
    id: "filterPanelContainer",
    ref: "filterPanelContainer",
    style: _ctx.panelDescriptor.style.filterPanelContainer
  }, [
    _createVNode("div", {
      id: "filterPanel",
      ref: "filterPanel",
      class: "p-d-flex filterPanel p-ai-center",
      style: _ctx.panelDescriptor.style.filterPanel,
      onDrop: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDrop($event))),
      onDragover: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
      onDragenter: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.displayDropzone && _ctx.displayDropzone(...args)))
    }, [
      (_ctx.showScroll)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            icon: "fas fa-arrow-circle-left",
            class: "p-button-text p-button-rounded p-button-plain p-ml-1",
            onClick: _ctx.scrollLeft
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        ref: "filterItemsContainer",
        class: "p-d-flex p-ai-center kn-flex",
        style: _ctx.panelDescriptor.style.containerScroll,
        onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
        onDragenter: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
        onDragleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hideDropzone && _ctx.hideDropzone(...args)))
      }, [
        (_ctx.filterCardList?.length == 0)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode(_component_InlineMessage, {
                class: "kn-flex p-m-1",
                style: _ctx.panelDescriptor.style.noFilters,
                severity: "info",
                closable: "false"
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.filterPanel.filterPanelEmpty')), 1)
                ]),
                _: 1
              }, 8, ["style"])
            ]))
          : (_openBlock(), _createBlock(_component_FilterCard, {
              key: 1,
              filterCardList: _ctx.filterCardList,
              olapDesigner: _ctx.olapDesigner,
              onShowMultiHierarchy: _ctx.emitMultiHierarchy,
              onOpenFilterDialog: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('openFilterDialog', $event)))
            }, null, 8, ["filterCardList", "olapDesigner", "onShowMultiHierarchy"])),
        _createVNode("div", {
          ref: "axisDropzone",
          class: "kn-flex kn-truncated p-mr-1",
          style: _ctx.panelDescriptor.style.filterAxisDropzone
        }, _toDisplayString(_ctx.$t('documentExecution.olap.filterPanel.drop')), 5)
      ], 36),
      (_ctx.showScroll)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            icon: "fas fa-arrow-circle-right",
            class: "p-button-text p-button-rounded p-button-plain p-mr-1",
            onClick: _ctx.scrollRight
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ], 36)
  ], 4))
})